import "./Destinations.module.css";
import Header from "@/reusable_sections/Header";
import MetropolitanPresence from "./sections/MetropolitanPresence";
import RegionalHighlights from "./sections/RegionalHighlights";
import Footer from "@/reusable_sections/Footer";
export default function DestinationsPage() {
  return <div>
      <Header />
      <MetropolitanPresence />
      <RegionalHighlights />
      <Footer />
    </div>;
}